import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { alphabet } from '../../../../static/utils';

const MultipleStatistic = ({ color, questions }) => {
    const reviewsCounts = useMemo(() => {
        return questions.map(q => q.reviews.length);
    }, [questions]);

    const maxCount = Math.max(...reviewsCounts);

    return (
        <div className="multiple-statistic">
            {reviewsCounts.map((question, index) => (
                <div key={index} className="multiple-statistic__item">
                    <div
                        style={{
                            backgroundColor: `${question === maxCount && question !== 0 && color}`,
                            borderColor: `${question === maxCount && question !== 0 && color}`,
                            color: `${question === maxCount && question !== 0 && '#464A55'}`,
                        }}
                        className="multiple-statistic__circle"
                    >
                        {alphabet[index]}
                    </div>
                    <span style={{ color: `${question === maxCount && question !== 0 && color}` }}>
                        {question}
                    </span>
                </div>
            ))}
        </div>
    );
};

MultipleStatistic.propTypes = {
    color: PropTypes.string.isRequired,
    questions: PropTypes.array.isRequired,
};

export default React.memo(MultipleStatistic);
